var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogocd2F6A51098336F66C866C2Dfe881423(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.948,
    height: 30.94,
    viewBox: "0 0 121.948 47.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M12.029,36.61,2.479,2.037C2.214,1.359,1.4,1.014,0,1.12V.85H9.063v.27c-1.328-.053-2,.164-1.89.757a.2.2,0,0,0,.053.159l7.447,26.914L21.845,5.273l-.916-3.236c-.217-.677-1.005-1.023-2.484-.916V.85H27.56v.27c-1.4-.053-2,.164-1.939.757a.2.2,0,0,1,.053.159l7.5,26.914L41.259,2.037c.217-.646-.443-.97-1.833-.916V.85h4.64v.27c-1.51,0-2.373.27-2.537.885L31.067,36.61h-.518l-8.6-30.961L12.622,36.61Z",
    transform: "translate(0 -0.474)",
    fill: "#1c1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5250",
    "data-name": "Path 5250",
    d: "M96.983,34.7v-.381c-.053-4.476,2.1-9.328,8.036-10.183,4.87-.376,7.659,1.939,8.359,7.013v.213H100.8a20.282,20.282,0,0,0,1.023,7.823c1.727,4.529,7.336,7.283,11.923,2.856a.4.4,0,0,0,.106.164,14.905,14.905,0,0,1-1.293,1.187c-7.969,5.393-15.589-1.771-15.589-8.682m3.83-3.542h9.329a8.573,8.573,0,0,0-.54-4.64,3.7,3.7,0,0,0-3.179-2.1.6.6,0,0,0-.27-.053,4.038,4.038,0,0,0-2,.483c-2.1,1.027-3.073,3.506-3.343,6.313m6.579,16.935a9.059,9.059,0,0,0,3.542,3.542v.376a9.6,9.6,0,0,0-3.453,3.453h-.483a9.076,9.076,0,0,0-3.347-3.4v-.443a8.926,8.926,0,0,0,3.4-3.542Z",
    transform: "translate(-54.038 -13.431)",
    fill: "#1c1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5251",
    "data-name": "Path 5251",
    d: "M166.8,26.365h.164L164.6,36.548H147.28v-.213c1.293-.053,2.05-.27,2.156-.753V1.766c-.106-.443-.885-.646-2.156-.7V.85h8.629v.217c-1.24.053-1.886.27-2.05.7V35.587c.164.483.81.7,2.05.753,6.9,0,9.439-3.719,10.9-9.975",
    transform: "translate(-82.073 -0.474)",
    fill: "#1c1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5252",
    "data-name": "Path 5252",
    d: "M212.641,0A17.967,17.967,0,0,1,230.5,18.121a17.855,17.855,0,1,1-35.707,0A18,18,0,0,1,212.641,0m4.821,2.267a13.782,13.782,0,0,0-10.626-.81,11.175,11.175,0,0,0-5.18,3.83,16.1,16.1,0,0,0-3.019,9.6c-.27,3.94.863,7.177,2.7,10.626A15.89,15.89,0,0,0,206.2,31.5c4.175,4.047,12.1,4.91,16.47.823,4.91-4.6,5.016-13.725,2.59-19.591-1.78-4.259-3.883-8.3-7.8-10.462m-3.883,11.6a9.032,9.032,0,0,0,3.542,3.542v.376a9.554,9.554,0,0,0-3.449,3.453h-.487a9.125,9.125,0,0,0-3.343-3.4v-.443a8.886,8.886,0,0,0,3.4-3.542Z",
    transform: "translate(-108.549)",
    fill: "#1c1b1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocd2F6A51098336F66C866C2Dfe881423);
export default __webpack_public_path__ + "static/media/Logo.cd2f6a51098336f66c866c2dfe881423.923a76ab8822f9660cf9297b2ec968f5.svg";
export { ForwardRef as ReactComponent };